import { render, staticRenderFns } from "./CreateEditTemplateStep.vue?vue&type=template&id=cf6b15a4&scoped=true&"
import script from "./CreateEditTemplateStep.vue?vue&type=script&lang=js&"
export * from "./CreateEditTemplateStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6b15a4",
  null
  
)

export default component.exports